import React from "react";
import useInput from "@ui/lib/hooks/useInput";
import t from "../../../../../i18n";
import type { ClassificationFailure } from "../../../../../api/useClassificationFailures";

export const useUnitInput = (selectedFailures: ClassificationFailure[]) => {
  const hasSameValue = React.useMemo(
    () =>
      selectedFailures.filter(
        failure =>
          "unit" in failure &&
          selectedFailures[0] &&
          "unit" in selectedFailures[0] &&
          failure.unit !== selectedFailures[0]?.unit,
      ).length === 0,
    [selectedFailures],
  );

  const defaultValue = React.useMemo(() => {
    if (hasSameValue)
      return selectedFailures[0] && "unit" in selectedFailures[0] && selectedFailures[0].unit
        ? selectedFailures[0].unit
        : "";
    return "";
  }, [selectedFailures, hasSameValue]);

  const { value, setValue, dirty, onChange } = useInput(defaultValue);

  //   const handleRollbackUnit = React.useCallback(() => {
  //     setUnit(defaultValue);
  //   }, [defaultValue, setUnit]);

  const placeholder = React.useMemo(() => {
    if (!hasSameValue) return t("administration.modal.multiple_value");
    if (defaultValue === "") return t("setup.paragraphs.quantities.table.definitions.column.unit");
    return defaultValue;
  }, [hasSameValue, defaultValue]);

  return {
    placeholder,
    value,
    setValue,
    onChange,
    dirty,
    // handleRollbackUnit,
  };
};
